module.exports = {
  "/": {
    "success": {
      "hubspot on credits page loaded": [
        "HUBSPOT_ON_CREDITS_PAGE"
      ],
      "hubspot on credits v2 page loaded": [
        "HSOC_V2_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "rootView"
  },
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "servicePage"
  },
  "/content": {
    "success": {
      "default": [
        "CONTENT_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "contentPage"
  },
  "/data": {
    "success": {
      "default": [
        "DATA_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "dataPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "commercePage"
  },
  "/revenue": {
    "success": {
      "default": [
        "COMMERCE_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "revenuePage"
  },
  "/suite": {
    "success": {
      "default": [
        "CUSTOMER_PLATFORM_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "marketingPlusPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE_V2"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE",
      "MERCH_CARD_ERROR"
    ],
    "name": "smartCrmPage"
  },
  "/hsoc-pricing": {
    "success": {
      "default": [
        "HSOC_PRICING_PREVIEW_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "hsocPricingPreviewPage"
  },
  "/hubspot-credits": {}
};